module.exports = __webpack_public_path__ + "ea2b886b6b0afec23ddc93da7a30a779.bg_main.webp";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_main.webp
// module id = xk/6
// module chunks = 0